import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=3f6c8f72&"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts&"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=3f6c8f72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports